import { render, staticRenderFns } from "./LookLogistics.vue?vue&type=template&id=49722baa&scoped=true"
import script from "./LookLogistics.vue?vue&type=script&lang=js"
export * from "./LookLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49722baa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49722baa')) {
      api.createRecord('49722baa', component.options)
    } else {
      api.reload('49722baa', component.options)
    }
    module.hot.accept("./LookLogistics.vue?vue&type=template&id=49722baa&scoped=true", function () {
      api.rerender('49722baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/goods/LookLogistics.vue"
export default component.exports